import {Col, Container, Modal, Row} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import {connectCompanyExtApp, saveEmployeeHomeLocation, saveHomeLocation} from "../common/api/WebApi";
import {CONSTANTS} from "../common/constants";
import {AppContext} from "../../lib/AppContext";

export default function MangeSquareHomeLocation({handleClose, handleSave, show, employee}) {

  const [context, setContext] = useContext(AppContext);
  const [locations, setLocations] = useState([]);
  const [saving, setSaving] = useState(false);
  const [squareConnected, setSquareConnected] = useState(false);

  const getCompanyExtAppData = () => {
    connectCompanyExtApp().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setLocations(result);
        if (result?.type == CONSTANTS.EXT_APPLICATION.SQUARE) {
          setSquareConnected(true);
        }
      }
    });
  }

  useEffect(() => {
    getCompanyExtAppData();
  }, [])

  const [syncingDevice, setSyncingDevice] = useState(false);
  const [activeDevice, setActiveDevice] = useState();

  const setHomeLocationFn = (app) => {
    setSyncingDevice(true);
    setActiveDevice(null);
    if (employee) {
      saveEmployeeHomeLocation(employee?.guid, app).then((resp) => {
        handleSave()
      });
    } else {
      saveHomeLocation(app).then((resp) => {
        handleSave()
      });
    }
  }

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Choose Home Location</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className={'col col-main'} xs={12}>
            <Container>
              <Row>
                <Col className={'col'} sm={12}>
                  {locations?.availableLocations?.length > 0 && <>
                    <MDTypography variant="h6">
                      Square Locations
                    </MDTypography>
                    <table className="table table-striped mt-2 mb-4">
                      <thead>
                      <tr>
                        <th>Name</th>
                        <th className={'text-right'}>Location</th>
                      </tr>
                      </thead>
                      <tbody>
                      {locations?.availableLocations?.map((a, idx) => {
                        return (
                          <tr key={idx}>
                            <td>{a.name}</td>
                            <td className={'text-right'}>
                              <MDButton
                                color="secondary"
                                size="small"
                                onClick={() => {
                                  setHomeLocationFn(a);
                                }}>Set As Home Location</MDButton>
                            </td>
                          </tr>
                        )
                      })}
                      </tbody>
                    </table>
                  </>
                  }
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

      </Modal.Body>
      <Modal.Footer>
        {activeDevice && <MDButton type="submit" color="info">
          {saving ? 'Saving...' : 'Save'}
        </MDButton>}
      </Modal.Footer>
    </Modal>
  );
}